let config = {
  api_host: "https://schedulingb2capi.rilivbackend.com/api-psycholog",
  // "https://dashboardapi.riliv.co.id/api-psycholog",
  // "https://devdashboardapi.riliv.id/api-psycholog",
  // "https://stagdashboardapi.riliv.id/api-psycholog",
};

export { config };
